/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Drawer, FilledButton } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const Placeholder = () => (
    <div className="n-size-full n-flex n-flex-col n-items-center n-justify-center n-rounded-md n-p-token-16 w-full">
      <div className="n-border-dashed n-border-2 n-border-light-primary-bg-strong n-size-full n-flex n-flex-col n-items-center n-justify-center n-rounded-md">
        <FilledButton onClick={() => setIsExpanded(true)}>
          Press to show the Drawer
        </FilledButton>
      </div>
    </div>
  );

  return (
    <div className="n-h-[calc(40vh-32px)] n-min-h-[700px] n-flex n-relative n-overflow-hidden">
      <Drawer
        type="overlay"
        isExpanded={isExpanded}
        onExpandedChange={() => setIsExpanded(false)}
        position="left"
        isCloseable={false}
      >
        <Drawer.Header>Drawer Header</Drawer.Header>
        <Drawer.Body>Lorem ipsum dolor sit amet.</Drawer.Body>
      </Drawer>
      <Placeholder />
    </div>
  );
};

export default Component;
